import React, { useContext } from 'react';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {
  EvidenceStateAction,
  NavigationContext,
  Tooltip,
} from '@eas/common-web';

export function Redirect({
  url,
  id,
  showRedirectInCurrent = true,
  showRedirectInNew = true,
}: {
  url: string | ((id: string) => string);
  id: string;
  showRedirectInCurrent?: boolean;
  showRedirectInNew?: boolean;
}) {
  const { navigate } = useContext(NavigationContext);

  const to = typeof url === 'function' ? url(id) : `${url}/${id}`;

  return (
    <>
      {showRedirectInCurrent && (
        <Tooltip title="Otvorí v aktuálnej karte">
          <OpenInBrowserIcon
            fontSize="small"
            color="primary"
            style={{ cursor: 'pointer', marginRight: 10 }}
            onClick={() =>
              navigate(to, false, {
                action: EvidenceStateAction.SHOW_ITEM,
                data: id,
              })
            }
          />
        </Tooltip>
      )}

      {showRedirectInNew && (
        <Tooltip title="Otvorí na novej karte">
          <OpenInNewIcon
            fontSize="small"
            color="primary"
            style={{ cursor: 'pointer', marginRight: 10 }}
            onClick={(e) => {
              e.stopPropagation();
              window.open(to);
            }}
          />
        </Tooltip>
      )}
    </>
  );
}
